module.exports = __webpack_public_path__ + "img/dmk_chibi-job_bnr@2x.add59d41.png";